export const bytesToHumanReadable = (
  bytes: number,
  options?: { digits?: number; space?: boolean }
) => {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1000, symbol: 'kB' },
    { value: 1000 ** 2, symbol: 'MB' },
    { value: 1000 ** 3, symbol: 'GB' },
    { value: 1000 ** 4, symbol: 'TB' },
    { value: 1000 ** 5, symbol: 'PB' }
  ]

  const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/
  const item = lookup.findLast((item) => bytes >= item.value)

  return item
    ? (bytes / item.value)
        .toFixed(options?.digits ?? 2)
        .replace(regexp, '')
        .concat(options?.space ? ' ' : '', item.symbol)
    : '0'
}
